export class WebhookV1StandardPayloadPolicyChange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadPolicyChangeTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadPolicyChangeArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadPolicyChange.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadPolicyChangeTypeEnum;
(function (WebhookV1StandardPayloadPolicyChangeTypeEnum) {
    WebhookV1StandardPayloadPolicyChangeTypeEnum["BackupPolicyCreated"] = "BACKUP_POLICY_CREATED";
    WebhookV1StandardPayloadPolicyChangeTypeEnum["BackupPolicyUpdated"] = "BACKUP_POLICY_UPDATED";
    WebhookV1StandardPayloadPolicyChangeTypeEnum["BackupPolicyDeleted"] = "BACKUP_POLICY_DELETED";
    WebhookV1StandardPayloadPolicyChangeTypeEnum["ClassificationPolicyCreated"] = "CLASSIFICATION_POLICY_CREATED";
    WebhookV1StandardPayloadPolicyChangeTypeEnum["ClassificationPolicyUpdated"] = "CLASSIFICATION_POLICY_UPDATED";
    WebhookV1StandardPayloadPolicyChangeTypeEnum["ClassificationPolicyDeleted"] = "CLASSIFICATION_POLICY_DELETED";
})(WebhookV1StandardPayloadPolicyChangeTypeEnum || (WebhookV1StandardPayloadPolicyChangeTypeEnum = {}));
